import PropTypes from 'prop-types';
export const hamburgerPropTypes = {
  onClick: PropTypes.func,
  isMobileOpen: PropTypes.bool,
  classname: PropTypes.string
};